import { Rule } from '../types';

export const ruleProductExists: Rule = (submission, catalog) => {
  const allSkus = [
    ...submission.options.accessories.map((a) => a.sku),
    ...submission.options.passeSeuils.map((p) => p.sku),
  ];

  const missing = allSkus.filter((s) => !catalog.products.has(s));
  if (missing.length === 0) return null;

  return {
    ruleId: 'product-not-in-catalog',
    severity: 'error',
    humanMessage: `Produit(s) introuvable(s) au catalogue : ${missing.join(', ')}. Alerter l'admin ?`,
  };
};
